/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseValidator} from "./BaseValidator";

export class UnsignedNumberValidator extends BaseValidator {
	constructor() {
		super();
	}

	name(model) {
		return "Must be a positive number"
	}

	logic(x) {
		// this validator doesn't mandate not-null or numeric
		// it should be used in conjunction with those other validators
		if (x != null && !isNaN(x)) {
			return (x >= 0);
		}
		return true;
	}

	message() {
		return "Must be a positive number";
	}
}